import { Route, Switch, BrowserRouter as Router } from "react-router-dom";

import AdminPage from "../Admin";
import React from "react";
import SupportPage from "../Support";
import WelcomePage from "../Welcome";

const Public = () => {
  return (
    <div className="PublicPage">
      <Router>
        <Switch>
          <Route path="/admin">
            <AdminPage />
          </Route>
          <Route path="/support">
            <SupportPage />
          </Route>
          <Route>
            <WelcomePage />
          </Route>
        </Switch>
      </Router>
    </div>
  );
};

export default Public;
